export default __webpack_public_path__ + "images/c60fb3f6abc2dbe56148889d3f5960a3-1_web_1919x543.webp";